import { Avatar } from 'antd';
import React from 'react';

import { NAME_AVATAR_COLORS } from './NameAvatar.constants';
import { AvatarPassthroughProps, NameAvatarProps } from './NameAvatar.types';

export default function NameAvatar({
  icon,
  name = '',
  color,
  ...restProps
}: NameAvatarProps) {
  const initials =
    name
      .replace(/\s+/g, ' ')
      .trim()
      .split(' ')
      .map((n) => n[0])
      .join('') ?? '';

  const avatarProps: AvatarPassthroughProps = {
    ...restProps,
    [typeof icon === 'string' ? 'src' : 'icon']: icon,
  };
  if (avatarProps.src && !avatarProps.alt) {
    avatarProps.alt = name || '';
  }
  // Provide an accessible label so screen readers announce the user's name
  // rather than reading out the initials letter by letter.
  if (!avatarProps['aria-label'] && name) {
    avatarProps['aria-label'] = name;
  }
  const backgroundColor = avatarProps.src
    ? ''
    : color ||
      NAME_AVATAR_COLORS[
        Math.round(
          (initials.toUpperCase().charCodeAt(0) - 65) /
            NAME_AVATAR_COLORS.length,
        )
      ];
  return (
    <Avatar
      name={name}
      {...avatarProps}
      style={{ backgroundColor, ...avatarProps.style }}
    >
      {!icon && initials}
    </Avatar>
  );
}
